import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { FavoritesContext } from "./FavoritesContext";
import { useToast } from "./ToastContext";
import productData from "../Datas/productData";
import "../css/shop.scss";

function Shop() {
  const { toggleFavorite, isFavorite } = useContext(FavoritesContext);
  const { showToast } = useToast();
  const [activeCategory, setActiveCategory] = useState("All");

  const categories = [
    "All",
    "Coats",
    "Dresses",
    "Bottoms",
    "Jumpsuits",
    "Tops",
  ];

  const filteredProducts =
    activeCategory === "All"
      ? productData
      : productData.filter((product) => product.category === activeCategory);

  const renderStars = (rating) => {
    if (!rating) return null;
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <span key={i} className="star filled">
            ★
          </span>
        );
      } else if (i === fullStars && hasHalfStar) {
        stars.push(
          <span key={i} className="star half">
            ★
          </span>
        );
      } else {
        stars.push(
          <span key={i} className="star empty">
            ☆
          </span>
        );
      }
    }
    return stars;
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const formatPrice = (price) => {
    const numeric = Number(price);
    if (Number.isNaN(numeric)) return price;
    return `€ ${numeric.toLocaleString("en-EU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const handleFavoriteClick = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    const result = toggleFavorite(productId);
    if (!result.success) {
      showToast(result.message, "warning");
    } else {
      showToast(result.message, "success");
    }
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  return (
    <div className="shop-wrapper color-scheme color-scheme--scheme-1">
      <Header />
      <main className="shop-page">
        <section className="shop-toolbar">
          <h1 className="shop-toolbar__title">
            FILTER AND ORDER({filteredProducts.length} Products)
          </h1>
          <div className="category-filters">
            {categories.map((category) => (
              <button
                key={category}
                type="button"
                className={`category-btn ${
                  activeCategory === category ? "is-active" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </section>

        <section className="product-grid" aria-label="Product listings">
          {filteredProducts.map((product) => {
            const [primaryImage, ...secondaryImages] = product.images;
            const isFav = isFavorite(product.id);
            return (
              <article className="product-card" key={product.id}>
                <Link
                  to={`/shopDetails/${product.id}`}
                  className="product-card__link"
                  onClick={toTop}
                >
                  <div className="product-card__media">
                    {primaryImage &&
                      (isVideo(primaryImage) ? (
                        <video
                          src={primaryImage}
                          className="product-card__image"
                          autoPlay
                          muted
                          loop
                          playsInline
                        />
                      ) : (
                        <img
                          src={primaryImage}
                          alt={product.name}
                          className="product-card__image"
                          loading="lazy"
                        />
                      ))}
                    <div className="product-card__thumbnails">
                      {secondaryImages
                        .slice(0, 2)
                        .map((thumb, index) =>
                          isVideo(thumb) ? (
                            <video
                              key={thumb}
                              src={thumb}
                              className="product-card__thumbnail"
                              autoPlay
                              muted
                              loop
                              playsInline
                            />
                          ) : (
                            <img
                              key={thumb}
                              src={thumb}
                              alt={`${product.name} view ${index + 2}`}
                              className="product-card__thumbnail"
                              loading="lazy"
                            />
                          )
                        )}
                    </div>
                  </div>
                  <div className="product-card__meta">
                    <span className="product-card__tag">NEW NOW</span>
                    <button
                      type="button"
                      className={`product-card__favorite ${
                        isFav ? "is-favorited" : ""
                      }`}
                      aria-label={
                        isFav ? "Remove from favorites" : "Add to favorites"
                      }
                      onClick={(e) => handleFavoriteClick(e, product.id)}
                    >
                      {isFav ? "♥" : "♡"}
                    </button>
                  </div>
                  <div className="product-card__details">
                    <p className="product-card__brand">{product.country}</p>
                    <h2 className="product-card__title">{product.name}</h2>
                    {product.rating && (
                      <div className="product-card__rating">
                        <div className="card-stars">
                          {renderStars(product.rating)}
                        </div>
                        <span className="card-rating-num">
                          {product.rating}
                        </span>
                        <span className="card-review-count">
                          ({product.reviewCount})
                        </span>
                      </div>
                    )}
                    <p className="product-card__price">
                      {formatPrice(product.price)}
                    </p>
                  </div>
                </Link>
              </article>
            );
          })}
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Shop;
